import { predictionAbi } from '@/libs/sdk/contracts/abis/prediction';
import { parseEventLogs, type TransactionReceipt } from 'viem';

export type TradeReceiptAmounts = { amountIn: bigint; amountOut: bigint };

// Decode the pool's Deposited/Withdrawn event off the tx receipt so the
// optimistic row can carry the ACTUAL on-chain amounts (post price-impact/fee)
// instead of the pre-trade form estimate. Any decode failure (unexpected ABI
// shape, no matching log for this market) degrades to undefined — callers
// fall back to the form values, never throw.
export const extractTradeAmounts = (
  receipt: TransactionReceipt,
  marketAddress: string,
  side: 'buy' | 'sell'
): TradeReceiptAmounts | undefined => {
  try {
    const logs = parseEventLogs({
      abi: predictionAbi,
      logs: receipt.logs,
      eventName: side === 'buy' ? 'Deposited' : 'Withdrawn',
    });
    const marketLower = marketAddress.toLowerCase();
    const match = logs.find(log => log.address.toLowerCase() === marketLower);
    if (!match) return undefined;
    const { amountIn, amountOut } = match.args as { amountIn: bigint; amountOut: bigint };
    return { amountIn, amountOut };
  } catch {
    return undefined;
  }
};
